import BaseInput from 'app/components/forms/base_input/component'
import { nullValidator, withValidation } from 'app/components/forms/util'

const InputTextOptional = withValidation(BaseInput, nullValidator)

export default InputTextOptional
